/* unplugin-vue-components disabled */import { render } from "./c-card-txt.vue?vue&type=template&id=59f52a0e&scoped=true"
import script from "./c-card-txt.vue?vue&type=script&lang=js"
export * from "./c-card-txt.vue?vue&type=script&lang=js"

import "./c-card-txt.vue?vue&type=style&index=0&id=59f52a0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f52a0e"]])

export default __exports__